(function () {
  function initCompareSlider(container) {
    if (!container || container.dataset.editorialCompareInit === 'true') return;

    var input = container.querySelector('[data-editorial-product-compare-input]');
    if (!input) return;

    container.dataset.editorialCompareInit = 'true';

    function updatePosition() {
      container.style.setProperty('--editorial-compare-position', input.value + '%');
    }

    input.addEventListener('input', updatePosition);
    input.addEventListener('change', updatePosition);
    updatePosition();
  }

  function initCompareSliders(scope) {
    scope.querySelectorAll('[data-editorial-product-compare]').forEach(initCompareSlider);
  }

  function init() {
    initCompareSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode && !window.editorialFeaturedProductCompareEditorInit) {
    window.editorialFeaturedProductCompareEditorInit = true;
    document.addEventListener('shopify:section:load', function (event) {
      initCompareSliders(event.target);
    });
  }
})();
